import React, { useMemo } from 'react';
import { channelInfo } from '@op/components/ChannelLabel';
import TableCommonHook from '@op/components/TableCommonHook';
import useLanguage from '@op/hooks/useLanguage';
import { dealWithOthersName } from '@op/utils/languageValue';
import { formatDateFunc } from '@op/utils/time';
import { reviewsFormat } from '@op/utils/value';

interface IRealtimeChannelLanguage {
  metrics: string;
  title: string;
  header: 'Channel' | 'Language';
  formatValue?: (value: string | number) => string | number;
  data: any;
  filter: any;
  maxHeight?: number;
}
export default function Table(props: IRealtimeChannelLanguage) {
  const { metrics, title, header, formatValue = reviewsFormat, filter, data, maxHeight = 315.5 } = props;
  const { formatMessage } = useLanguage();
  const columns = useMemo(() => {
    return [
      {
        header: formatMessage({ id: 'Date' }),
        key: 'time',
        align: 'left',
        fixed: 'left',
        render: ({ time }: any) => {
          return formatDateFunc(filter?.date_type || 'hourly')?.(time) || time;
        },
      },
      {
        header: formatMessage({ id: header }),
        key: 'name',
        align: 'left',
        render: (cvm: any) => {
          if (header === 'Channel') {
            const { img, name } = channelInfo(cvm.name);
            return (
              <div className="channel-language-div">
                <img src={img} />
                <span className="channel-language-span">
                  {name}
                </span>
              </div>
            );
          }
          return dealWithOthersName(cvm.name, header.toLocaleLowerCase());
        },
      },
      {
        header: formatMessage({ id: title }),
        key: metrics,
        align: 'right',
        render: (cvm: any) => formatValue(cvm?.[metrics] || 0),
      }
    ];
  }, [metrics, title, header]);

  return (
    <TableCommonHook
      recordKey={['time', 'name']}
      columns={columns}
      records={data}
      hasPageable={false}
      maxHeight={maxHeight}
      bordered
      minWidth={'auto'}
    />
  );
}